import { Button } from "antd";
import WelcomeTopbar from "../../components/common/header/WelcomeTopbar";
import { Navigate, useNavigate } from "react-router-dom";
import TodaysOverview from "../../components/dashboard/TodaysOverview";
import CurrentOrders from "../../components/dashboard/CurrentOrders";
import AgingReturns from "../../components/dashboard/AgingReturns";
import WarehouseInventory from "../../components/dashboard/WarehouseInventory";
import { useCurrentUser } from "../../api/hooks/auth";

function Dashboard() {
  const navigate = useNavigate();
  const { data: userData, isLoading } = useCurrentUser();

  if (isLoading) return <div>Loading...</div>;
  if (
    userData?.type?.name == "PROCESSOR" ||
    userData?.type?.name == "CUSTOMER"
  ) {
    return <Navigate to="/processes/order" />;
  }

  return (
    <div className="flex flex-col gap-6">
      <WelcomeTopbar />
      <div className="flex flex-col gap-4 px-6 pb-6">
        <div className="flex flex-col gap-4 rounded-xl border-2 pb-4">
          <div className="flex rounded-t-xl bg-[#D1DFFF] px-6 py-1">
            <div className="flex gap-2 text-lg">
              <div>Create</div>
            </div>
          </div>
          <div className="flex gap-6 px-6">
            <Button
              className="flex-grow"
              onClick={() => {
                navigate("/processes/order/add");
              }}
            >
              Outbound Order
            </Button>
            <Button
              className="flex-grow"
              onClick={() => {
                navigate("/processes/order/add");
              }}
            >
              Inbound Order
            </Button>
            <Button
              className="flex-grow"
              onClick={() => {
                navigate("/setup/contacts/add");
              }}
            >
              Contact
            </Button>
          </div>
        </div>
        <TodaysOverview />
        <div className="flex gap-6">
          <CurrentOrders />
          <div className="flex w-1/2 flex-col gap-6">
            <WarehouseInventory />
            <AgingReturns />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
